import { render } from "./SidebarServiceStatus.vue?vue&type=template&id=47fde555&scoped=true&lang=pug"
import script from "./SidebarServiceStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarServiceStatus.vue?vue&type=script&setup=true&lang=js"

import "./SidebarServiceStatus.vue?vue&type=style&index=0&id=47fde555&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fde555"]])

export default __exports__